import { environment } from '../../environments/environment';
import { BEACONSTAC_ADMIN, BEACONSTAC_HOSTS } from '../app.constants';

export enum PRODUCT_TYPES {
    QR = 'qr',
    DBC = 'dbc',
}

export const DBC_LANGUAGE_SPECIFIC_FIELDS = [
    'first_name',
    'last_name',
    'prefix',
    'suffix',
    'designation',
    'department',
    'pronouns_v2',
    'company',
    'summary',
    'logo_url',
    'phone',
    'phone_v2',
    'email',
    'email_v2',
    'website',
    'website_v2',
    'custom_fields',
    'address_url',
    'address_v2',
    'social_links',
    'user_image_url',
    'contact_info_ordering',
    '__contact_info_list__',
];

export class Utils {
    public static getJSON(url: string) {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('GET', url, true);
            xhr.responseType = 'json';
            xhr.onload = function () {
                const status = xhr.status;
                if (status === 200) {
                    resolve(xhr.response);
                } else {
                    reject(xhr.response);
                }
            };
            xhr.send();
        });
    }

    public static getQueryMap(query: string) {
        // if (typeof query !== 'string') {
        //   return null;
        // }

        const toType = function (a: any) {
                // @ts-ignore
                return {}.toString
                    .call(a)
                    .match(/\s([a-zA-Z]+)/)[1]
                    .toLowerCase();
            },
            map = {};

        const sanitize = function (match: string, key: string, value: string) {
            if (key in map) {
                // @ts-ignore
                if (toType(map[key]) !== 'array') {
                    // @ts-ignore
                    map[key] = [map[key]];
                }
                // @ts-ignore
                map[key].push(decodeURIComponent(value));
            } else {
                // @ts-ignore
                map[key] = decodeURIComponent(value);
            }
        };

        // @ts-ignore
        query.replace(/([^&|\?=]+)=?([^&]*)(?:&+|$)/g, sanitize);
        return map;
    }

    public static isWhiteLabeledDashboard() {
        const host = window.location.hostname.toLowerCase();
        return (
            (BEACONSTAC_HOSTS.indexOf(host) === -1 &&
                host.indexOf('beaconstac.com') === -1 &&
                host.indexOf('uniqode.com') === -1 &&
                host.indexOf('amplifyapp.com') === -1) ||
            host === BEACONSTAC_ADMIN
        );
    }
}

export function isBeaconstacDomainRequest() {
    const domainString = 'domain=beaconstac';
    return (
        window.location.search.indexOf(domainString) !== -1 ||
        document.cookie.indexOf(domainString) !== -1
    );
}

export function getAuth0Domain() {
    const domainString = 'domain=beaconstac; path=/; domain=.uniqode.com;';
    if (isBeaconstacDomainRequest()) {
        document.cookie = domainString;
        return environment.auth0Domain.replace('uniqode', 'beaconstac');
    }
    return environment.auth0Domain;
}

export class PageAttributes {
    pageNumber: number = 1;
    ascending: boolean = true;
    pageSize: number = 5;

    constructor(json?: any) {
        this.pageNumber = json?.pageNumber;
        this.ascending = json?.ascending;
        this.pageSize = json?.pageSize;
    }
}

export interface Typography {
    font_type: string;
    font_family: string;
    personal_info: {
        google_font_style?: string;
        google_font_size?: number;
        google_font_colour?: string;

        custom_font_style?: string;
        custom_font_url?: string;
        custom_font_size?: number;
        custom_font_colour?: string;
    };
    company_details: {
        google_font_style?: string;
        google_font_size?: number;
        google_font_colour?: string;

        custom_font_style?: string;
        custom_font_url?: string;
        custom_font_size?: number;
        custom_font_colour?: string;
    };
    contact_details: {
        google_font_style?: string;
        google_font_size?: number;
        google_font_colour?: string;

        custom_font_style?: string;
        custom_font_url?: string;
        custom_font_size?: number;
        custom_font_colour?: string;
    };
    button: {
        google_font_style?: string;
        google_font_size?: number;
        google_font_colour?: string;

        custom_font_style?: string;
        custom_font_url?: string;
        custom_font_size?: number;
        custom_font_colour?: string;
    };
    bio: {
        google_font_style?: string;
        google_font_size?: number;
        google_font_colour?: string;

        custom_font_style?: string;
        custom_font_url?: string;
        custom_font_size?: number;
        custom_font_colour?: string;
    };
}

export class CustomFontObject {
    name: string;
    value: string;
    isHeader?: boolean;
    isClickable?: boolean;
}

export function deepCopy<T>(obj: T): T {
    if (obj === null || typeof obj !== 'object') {
        return obj;
    }

    if (Array.isArray(obj)) {
        const newArray: any[] = [];
        for (const item of obj) {
            newArray.push(deepCopy(item));
        }
        return newArray as T;
    }

    const newObj: Record<string, any> = {};
    for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
            newObj[key] = deepCopy(obj[key]);
        }
    }
    return newObj as T;

    /*
      Example usage:
      const originalObject = {
          name: 'John',
          age: 30,
          address: {
              city: 'Mumbai',
              country: 'India',
          },
      };
      const copiedObject = deepCopy(originalObject);
      console.log(copiedObject);
  */
}

export enum PRODUCT_STATE {
    ACTIVE = 'A',
    SLEEPING = 'S',
}

export enum INSTALL_CTA_SOURCE {
    MYCARDS_HOME_PAGE = 'mycards_home_page',
    MYCARDS_LANDING_PAGE = 'mycards_landing_page',
}

export function isValidEmail(email: string) {
    const emailRegexp = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    return emailRegexp.test(email);
}

export function isValidPhoneNumber(phoneNumber: string) {
    if(phoneNumber.length == 0) return true;
    const phoneRegexp = /^[+]?[(]?[0-9]{1,4}[)]?[-\s./0-9]{6,15}$/;
    return phoneRegexp.test(phoneNumber.toString());
}

export function truncateField(label:string,maxLength:number):string {
    const length = label.length;
    if(length > maxLength) {
        return label.substring(0,maxLength - 3) + '...';
    }
    return label;
}